
import { useEffect, useState } from "react";
import axios from "axios";
import BestAtStoreSection from "./BestAtStoreSection";
import "./BestAtStores.css";

function BestAtStores() {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}website/stores_with_deals`
        );
        if (data?.success) setStores(data.data);
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };
    fetchStores();
  }, []);

  if (loading || stores.length === 0) return null;

  return (
    <section className="new-arrival-carousel-section" style={{ marginBottom: "40px" }}>
      {stores.map((store) => (
        <BestAtStoreSection key={store._id} store={store} />
      ))}
    </section>
  );
}

export default BestAtStores;
